import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTable.js";
import { useMemo, React, useEffect, useContext } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import Moment from "moment";
import { MainContext } from "context/MainContext.js";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const SessionList = () => {
  const history = useHistory();
  const location = useLocation();
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["admin.sessions.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "IP Address",
        accessor: "ipAddress",
        sortBy: "ipAddress",
        flex: "1 1 0",
      },
      {
        Header: "Username",
        accessor: "username",
        sortBy: "username",
        flex: "1 1 0",
      },
      {
        Header: "Accessed Time",
        accessor: "accessedTime",
        sortBy: "lastActivity",
        Cell: (props) => {
          return (
            <div>
              {props.value
                ? Moment(props.value).format("yy-MM-DD hh:mm a")
                : ""}
            </div>
          );
        },
        flex: "1 1 0",
      },
      {
        Header: "Privileges",
        accessor: "privilegeLevel",
        sortBy: "privilegeLevel",
        flex: "1 1 0",
      },
    ],
    []
  );

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardBody>
              <Breadcrumb>
                <BreadcrumbItem>
                  <NavLink
                    to={{
                      pathname: "/admin/dashboard",
                    }}
                  >
                    <FontAwesomeIcon icon={faHome} />
                  </NavLink>
                </BreadcrumbItem>
                <BreadcrumbItem>Active Sessions</BreadcrumbItem>
              </Breadcrumb>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <ReactTable
                query="/api/v1/session/list"
                columns={columns}
                title="Active Sessions"
                className="-striped -highlight primary-pagination"
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SessionList;
